module.exports = __webpack_public_path__ + "img/Logo_hapert_transparent.d91910ed.png";